<template>
<CustomInput
  v-bind="$attrs"
  v-on="$listeners"
  :type="reveal ? 'text' : 'password'"
  class="password-input-component"
>
  <!-- tabindex="-1" so it's not accidently triggered, and it's of no use for people with no vision. -->
  <button
    @click="reveal = !reveal"
    type="button"
    class="password-input-component__reveal-password"
    tabindex="-1"
  >
    <img :src="require('@/assets/images/icons/icon-eye-open.svg')">
  </button>
</CustomInput>
</template>

<script>
import CustomInput from '@/components/inputs/CustomInput';

export default {
  inheritAttrs: false,
  components: { CustomInput },
  data() {
    return {
      reveal: false,
    }
  }
}
</script>

<style lang="less">
.password-input-component {
  .custom-field__field-wrapper {
    @apply relative;
  }
  &__reveal-password {
    @apply absolute right-0 bottom-0 h-full px-2;
  }
}
</style>
